import { fetchFromGraphql, mutateGraphql } from 'app/sdk/utils/graphql';
import { buildPatchDefault } from 'app/sdk/utils/kazoo';

///////////////
// TODO: jsDoc!
///////////////

const exports = {
  // Queries
  // - graphql
  query: {
    // TODO: pagination
    callDetailRecords: (vars, fetchOptions) =>
      fetchFromGraphql('callDetailRecords', vars, fetchOptions),
    cdrInteractions: (vars, fetchOptions) =>
      fetchFromGraphql('cdrInteractions', vars, fetchOptions),

    // // Fetch a single callDetailRecord by id
    callDetailRecordsReport: (vars, fetchOptions) =>
      fetchFromGraphql('callDetailRecordsReport', vars, fetchOptions),
    // callDetailRecordById: (vars, fetchOptions) =>
    //   fetchFromGraphql('callDetailRecordById', vars, fetchOptions),
  },

  // Mutations
  // - via graphql, for transforming "strategy->flow"
  mutate: {},
};

export default exports;
